import {Component} from '@angular/core';
import {ContainerUserCustomerComponent} from "@_basic/layout/container-user-customer/container-user-customer.component";

@Component({
  selector: 'layout-container-user-customer',
    standalone: false,
  templateUrl: './sub-container-user-customer.component.html',
  styleUrls: ['./sub-container-user-customer.component.scss']
})
export class SubContainerUserCustomerComponent extends ContainerUserCustomerComponent {

}
